import { t } from "../../../../../utils/i18n";
import React, { useEffect } from "react";
import { Field, FormikHelpers, FormikErrors } from "formik";
import { required } from "../../../../../utils/formValidations";

interface Props {
  countryCode: string;
  apiErrors?: any;
  errors: FormikErrors<{
    authorized_payment_accepted: string;
  }>;
  setFieldValue: (field: string, value: any) => void;
  validateForm: () => Partial<FormikHelpers<any>>;
  handleNextStepChange: (
    validateForm: () => Partial<FormikHelpers<any>>,
    step: string
  ) => void;
  handlePreviousStepChange: (step: string) => void;
}

const Terms: React.FC<Props> = ({
  countryCode,
  errors,
  apiErrors,
  validateForm,
  setFieldValue,
  handleNextStepChange,
  handlePreviousStepChange,
}) => {
  useEffect(() => {
    // Initialize all tooltips
    ($('[data-toggle="tooltip"]') as any).tooltip();
  }, []);
  return (
    <>
      <div className="card-body">
        <div id="identification-details" className="request-details-cont">
          <div className="request-left-col">
            <i className="fa fa-id-card card-mail-icon"></i>
            <br />
            <h4 className="card-reqform-title">{t("cards.request_form.terms_and_conditions_2")}</h4>
          </div>
          <div className="row card-deck mb-5 request-right-col">
            <form className="col-md-12">
              <div className="">
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="authorized_payment_accepted"
                    className="form-check-input"
                    placeholder={t("cards.request_form.e_g_10_000")}
                    validate={required}
                  />
                  <label className="form-check-label" htmlFor="terms_accepted">
                    {t("cards.request_form.i_authorize_my_wallet_to_be")}
                  </label>
                  {errors.authorized_payment_accepted &&
                    !apiErrors?.authorized_payment_accepted && (
                      <small className="error" style={{ display: "block" }}>
                        {errors.authorized_payment_accepted}
                      </small>
                    )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="p-3">
        <div className="d-flex flex-row justify-content-between">
          <button
            type="button"
            className="btn btn-outline-purple float-left"
            onClick={(e) => handlePreviousStepChange("personal")}
          >
            <i className="fa fa-arrow-left"></i> {t("cards.request_form.previous")}
          </button>
          <button
            type="button"
            className="btn btn-purple float-right"
            onClick={(e) => handleNextStepChange(validateForm, "preview")}
          >
            {t("cards.request_form.next")} <i className="fa fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </>
  );
};

export default Terms;
